// Lo marcado en el 04, el «Sin promo» y lo soltado por contado, por venta: sobrevive un F5 y otra
// pestaña del mismo equipo (localStorage); en otro equipo no está.
import { PHONE_DRAFT_MAX_AGE_MS, PHONE_DRAFT_STORAGE_PREFIX } from '../constants';
import type { PhoneDraft } from './phoneDraft';
import type { SureKeepReleased } from './sureKeepRelease';

export interface StoredDraft {
    phoneDraft?: PhoneDraft;
    saleDeclined?: boolean;
    /** Lo solo SureKeep que soltó contado; se reaparta al volver a SureKeep aunque haya F5. */
    sureKeepReleased?: SureKeepReleased;
}

/** El almacenamiento del navegador; guarda ids de promos, SKU y el código, sin tokens ni PII. */
function storage(): Storage {
    // eslint-disable-next-line no-restricted-syntax -- ids de promos, SKU y código, sin tokens ni PII
    return window.localStorage;
}

/** Lo guardado con la hora en que se guardó, para olvidar ventas abandonadas. */
interface StoredEntry extends StoredDraft {
    savedAt?: number;
}

/** Lo guardado de la sesión; vacío sin almacenamiento o con un valor ilegible. */
export function readStoredDraft(sessionId: string): StoredDraft {
    try {
        const raw = storage().getItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId);
        if (!raw) return {};
        const parsed = JSON.parse(raw) as StoredEntry | null;
        if (!parsed || typeof parsed !== 'object') return {};
        const { savedAt: _savedAt, ...draft } = parsed;
        return draft;
    } catch {
        return {};
    }
}

/** Quita lo guardado de ventas que no se tocan desde hace más de `PHONE_DRAFT_MAX_AGE_MS`. */
function forgetStale(now: number): void {
    for (let i = storage().length - 1; i >= 0; i--) {
        const key = storage().key(i);
        if (!key?.startsWith(PHONE_DRAFT_STORAGE_PREFIX)) continue;
        try {
            const savedAt = (JSON.parse(storage().getItem(key) ?? '{}') as StoredEntry).savedAt;
            if (savedAt === undefined || now - savedAt > PHONE_DRAFT_MAX_AGE_MS) {
                storage().removeItem(key);
            }
        } catch {
            storage().removeItem(key);
        }
    }
}

export function writeStoredDraft(sessionId: string, value: StoredDraft): void {
    try {
        const now = Date.now();
        forgetStale(now);
        const entry: StoredEntry = { ...value, savedAt: now };
        storage().setItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId, JSON.stringify(entry));
    } catch {
        // Sin almacenamiento lo marcado vive solo en memoria.
    }
}

export function clearStoredDraft(sessionId: string): void {
    try {
        storage().removeItem(PHONE_DRAFT_STORAGE_PREFIX + sessionId);
    } catch {
        // Sin almacenamiento no hay nada que borrar.
    }
}
